import PaymentPlanTwoFactorAuthenticationError from './PaymentPlanTwoFactorAuthenticationError';
class CannotResendToken extends PaymentPlanTwoFactorAuthenticationError {
    constructor(options) {
        super('Cannot be resend token', options);
    }
}
export default CannotResendToken;
